module.exports = __webpack_public_path__ + "assets/f8a800ad7e4395f0e1808c33eabfe86b.svg";